/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { OperationType } from 'relay-runtime';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import PrivatePageGroupAssignmentsQuery$parameters, {
	type PrivatePageGroupAssignmentsQuery,
} from '@atlassian/status-page/private-page-group-assignments-query/__generated__/PrivatePageGroupAssignmentsQuery.graphql';

type CommunicationsStatusPageConfigurationsEntrypointComponent = EntryPointComponent<
	{
		PrivatePageGroupAssignmentsQuery?: PrivatePageGroupAssignmentsQuery;
	} & Record<string, OperationType>,
	// oxlint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-explicit-any
	Record<string, EntryPoint<any, any> | undefined>,
	{},
	{} | null
>;

export const communicationsStatusPageConfigurationsEntrypoint: EntryPoint<
	CommunicationsStatusPageConfigurationsEntrypointComponent,
	EntryPointRouteParams
> = createEntryPoint({
	root: JSResourceForUserVisible<CommunicationsStatusPageConfigurationsEntrypointComponent>(
		/* webpackChunkName: "async-communications-status-page-configurations-entrypoint" */ './ui/StatusPageConfigurationPage.tsx',
		{
			entryFsSsrLiftImportToModule: true,
		},
	),
	getPreloadProps: ({ context, tenantContext }: EntryPointRouteParams) => {
		const pageId = context.match.params.pageId || '';
		// Don't kick off the query without a pageId — Relay would still fire and the
		// server would error.
		if (!pageId) {
			return {};
		}
		return {
			queries: {
				PrivatePageGroupAssignmentsQuery: {
					parameters: PrivatePageGroupAssignmentsQuery$parameters,
					variables: {
						pageId,
						cloudId: tenantContext.cloudId,
					},
					options: {
						// Warm the Relay store so the layout's imperative `fetchQuery` can
						// hit the in-memory cache instead of round-tripping the network.
						fetchPolicy: 'store-and-network' as const,
					},
				},
			},
		};
	},
});
